module.exports = __webpack_public_path__ + "img/fi-rr-time-fast.b646db94.svg";